import PropTypes from 'prop-types';
import { List } from 'framework7-react';
import React, { useEffect } from 'react';

import { I18n } from 'Locales';
import { mockFunction } from 'Helpers';
import { SearchAndSelect, TextField } from 'Components';

const handleSelect = ({ callback, items, key, marketingCompanyId, updateTransientProps }, e) => {
  const selectedIndex = e.target.value;
  const selectedOption = items[selectedIndex];

  updateTransientProps({ [key]: selectedOption.id, [`${key}_type`]: selectedOption.client_type });
  callback && callback({ marketingCompanyId, clientId: selectedOption?.id });
};

const handleSelectSigner = (updateTransientProps, key, e) => {
  updateTransientProps({ [key]: e.target.value });
};

const renderOptions = ({ options, type }) => {
  const selectableOptions = options.map((option, index) => (
    <option key={option.id || index} value={index}>
      {option.name}
    </option>
  ));
  selectableOptions.unshift(
    <option key="default" value="" disabled selected={true}>
      {I18n.t(`admin:reOnboardModal.${type}`)}
    </option>
  );

  return selectableOptions;
};

const renderSigners = ({ signers }) => {
  const selectableOptions = signers.map((signer = {}, index) => (
    <option key={index} value={signer?.signer?.id} select={index[0]}>
      {signer?.signer?.full_name}
    </option>
  ));

  return selectableOptions;
};

const ReonboardModal = ({
  campaigns = [],
  clients = [],
  getCampaignsByClient = mockFunction,
  selected_client = '',
  selectedRows = [],
  signers = [],
  updateTransientProps = mockFunction
}) => {
  const marketingCompanyId = selectedRows?.[0]?.marketing_company?.id;

  useEffect(() => {
    updateTransientProps({ selected_signer: signers[0]?.signer?.id });
  }, [signers]);

  return (
    <>
      <List noHairlines className="w-full">
        <TextField
          label={I18n.t('admin:reOnboardModal.client')}
          onChange={handleSelect.bind(null, {
            callback: getCampaignsByClient,
            items: clients,
            key: 'selected_client',
            marketingCompanyId,
            updateTransientProps
          })}
          type="select">
          {renderOptions({ options: clients, type: 'clientPlaceholder' })}
        </TextField>

        <SearchAndSelect
          displayProperty="name"
          fieldName="selectedCampaigns"
          label={I18n.t('admin:reOnboardModal.campaign')}
          multiple={true}
          options={campaigns}
          resetKey={selected_client}
          selectedProperty="id"
          updateTransientProps={updateTransientProps}
        />

        <TextField
          label={I18n.t('admin:reOnboardModal.signers')}
          onChange={handleSelectSigner.bind(null, updateTransientProps, 'selected_signer')}
          type="select">
          {renderSigners({ signers })}
        </TextField>
      </List>

      <div className="names-container">
        {selectedRows.map((profile, index) => (
          <span key={index} className="text-sm font-bold mr-4">
            {profile.name}
            {index < selectedRows.length && ','}
          </span>
        ))}
        <span>{I18n.t('admin:reOnboardModal.willBeReOnboarded')}</span>
      </div>
    </>
  );
};

ReonboardModal.propTypes = {
  campaigns: PropTypes.array,
  clients: PropTypes.array,
  getCampaignsByClient: PropTypes.func,
  reuse_existing_badge_number: PropTypes.bool,
  selected_client: PropTypes.string,
  selectedRows: PropTypes.array,
  signers: PropTypes.array,
  updateTransientProps: PropTypes.func
};

export default ReonboardModal;
